{
  "rangeOverflow": "Η τιμή πρέπει να είναι {maxValue} ή παλαιότερη.",
  "rangeReversed": "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης.",
  "rangeUnderflow": "Η τιμή πρέπει να είναι {minValue} ή μεταγενέστερη.",
  "unavailableDate": "Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη."
}
